import { FilterChip } from "plos/src/components/Chip";
import { chipRowStyles } from "plos/src/components/FilterSheet/FilterChipRow/filterChipRow.css";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { getModifiedFilterIds } from "../utils";

interface MatchesFiltersProps {
  entryNumber: number;
  eventNumber: number;
  isDisabled: boolean;
  handleResetFilters: () => void;
  defaultFilters: { entry: number; event: number };
  children: ReactNode;
}

const MatchesFilters = ({
  entryNumber,
  eventNumber,
  isDisabled,
  handleResetFilters,
  defaultFilters,
  children,
}: MatchesFiltersProps) => {
  const { t } = useTranslation();
  const modifiedFilterIds = getModifiedFilterIds(
    { entry: entryNumber, event: eventNumber },
    defaultFilters,
  );
  const hasModifiedFilters = Object.keys(modifiedFilterIds).length > 0;

  return (
    <div role="group" className={chipRowStyles}>
      {children}
      <FilterChip
        label={t("reset", "Reset") as string}
        onClick={handleResetFilters}
        isDisabled={isDisabled || !hasModifiedFilters}
        mode="reset"
      />
    </div>
  );
};

export default MatchesFilters;
